import { render, staticRenderFns } from "./CustomBtn.vue?vue&type=template&id=492ae881&"
import script from "./CustomBtn.vue?vue&type=script&lang=js&"
export * from "./CustomBtn.vue?vue&type=script&lang=js&"
import style0 from "./CustomBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports